export function parseBoolean(value?: string | number | boolean | null) {
    value = value?.toString().toLowerCase();
    return value === "true";
}